import { Alert, Box, Button, LinearProgress, MenuItem, Stack, TextField, Typography } from "@mui/material";
import Layout from "../../Frames/Layout"
import { useEffect, useState } from "react";
import Loader from "../../Tools/Loader"
import { useNavigate, useParams } from "react-router-dom";
import API from "../../../services/API";
import { LoadingButton } from "@mui/lab";
import Checkbox from "../../Inputs/Checkbox"

export default function ActionForm(){

    const {id} = useParams()

    const navigate = useNavigate()

    const [item, setItem] = useState({})
    const [medias, setMedias] = useState(null)
    const [status, setStatus] = useState('loading')

    const statusIs = str => str === status
    const statusIn = arr => arr.includes(status)

    useEffect(() => {

        API.get('/sticker/medias')
            .then(r => setMedias(r.data))

        if(id === 'new'){

            setItem({
                shipments: 1,
                media: {id: 'email'},
                type: {id: 'marketing'},
                tags: ''
            })

            setStatus('ready')

        }else{

            API.get(`/sticker/actions/${id}`)
                .then(r => {
                    setItem(r.data)
                    setStatus('ready')
                })
        }        

    }, [id])

    const handleSubmit = e => {
        e.preventDefault();
        
        setStatus('submit');

        (id === 'new' ? API.post('/sticker/actions', item) : API.put(`/sticker/actions/${id}`, item))
            .then(r => handleSuccess(r))
            .catch(e => setStatus('error'))
    }

    const handleSuccess = r => {
        console.log(r.data)

        setStatus('success')

        setTimeout(() => navigate('/marketing/sticker/actions'), 3000)
    }

    const sx = {maxWidth: 600, margin: 'auto'}

    return <Layout menu="marketing" tab="sticker" back>

        {statusIn(['ready','submit','error']) && 
        
            <form onSubmit={handleSubmit} style={sx}>

                <Stack spacing={3}>

                    <Typography variant='h1'>Action Marketing</Typography>

                    {statusIs('error') && 
                        <Alert severity='error'>
                            Une erreur s'est produite. Veuillez vérifier le formulaire et réessayer.
                        </Alert>
                    }

                    <TextField 
                        label='Titre'
                        value={item.title || ''}
                        onChange={e => setItem({...item, title: e.target.value})}
                        required
                        size='small'
                        inputProps={{maxLength: 255}}
                    />

                    {medias && <TextField 
                        label='Media'
                        select
                        value={medias ? (item.media?.id || '') : ''}
                        onChange={e => setItem({...item, media: medias.find(m => m.id === e.target.value)})}
                        required
                        size='small'
                    >
                        {medias.map(m => 
                            <MenuItem key={m.id} value={m.id}>{m.title}</MenuItem>    
                        )}
                    </TextField>}

                    <TextField 
                        label='URL cible'
                        type="url"
                        value={item.targetUrl || ''}
                        onChange={e => setItem({...item, targetUrl: e.target.value})}
                        required
                        size='small'
                        inputProps={{maxLength: 255}}
                    />

                    <TextField 
                        label="Nombre d'envois"
                        type="number"
                        value={item.shipments}
                        onChange={e => setItem({...item, shipments: parseInt(e.target.value)})}
                        required
                        size='small'
                        inputProps={{step: 1, min: 1}}
                        helperText="Ex. : Nombre d'emails envoyés"
                    />

                    <TextField 
                        label='Mots clés'
                        value={item.tags || ''}
                        onChange={e => setItem({...item, tags: e.target.value})}
                        size='small'
                        inputProps={{maxLength: 255}}
                    />


                    <Stack spacing={1}>

                        <Checkbox
                            label="Lien partagé par un formateur"
                            value={item.teacher ? true : false}
                            onChange={e => setItem({...item, 
                                teacher: e.target.checked ? {email: ''} : null
                            })}
                        />

                        {item.teacher &&
                            <TextField 
                                label='Email du compte formateur LearnyLib'
                                type='email'
                                value={item.teacher?.email || ''}
                                onChange={e => setItem({...item, teacher: {email: e.target.value}})}
                                size='small'
                                inputProps={{maxLength: 255}}
                                required
                            />
                        }

                    </Stack>

                    <Stack direction='row' justifyContent='space-between'>
                        
                        <Button variant='outlined' onClick={() => navigate(-1)}>Annuler</Button>
                        
                        <LoadingButton
                            variant='contained'
                            type='submit'
                            loading={statusIs('submit') }
                        >
                            Valider
                        </LoadingButton>

                    </Stack>

                </Stack>

            </form>
        }


        {statusIs('loading') && <Loader />}


        {statusIs('success') && <Box sx={sx}>
                        
            <LinearProgress color='success' />

            <Alert severity='success'>
                Vos modifications ont bien été enregistrées.
            </Alert>

        </Box>}

    </Layout>
}